import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

export const Discussions = () => (
	<Switch>
		<Route path="/admin/discussions" exact component={List} />
		{/* <Route path="/admin/discussions/create" component={Edit} /> */}
		<Route path="/admin/discussions/:id" component={Edit} />
	</Switch>
);
